exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CtnStatus_limits_2Qm6 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n\n  max-width: 540px;\n}\n\n  .CtnStatus_limits__item_3Xg7 {\n    padding-left: 4%;\n\n    display: -webkit-box;\n\n    display: -webkit-flex;\n\n    display: -ms-flexbox;\n\n    display: flex;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n\n    width: 33.33333%;\n  }\n\n  .CtnStatus_limits__item--bordered_2ruI {\n      border-left: 1px solid #dfe0e5;\n    }\n\n  .CtnStatus_limits__item--zero-left-padding_1WvT {\n      padding-left: 0;\n\n      width: calc(33.33333% - 46px);\n    }\n", ""]);

// exports
exports.locals = {
	"limits": "CtnStatus_limits_2Qm6",
	"limits__item": "CtnStatus_limits__item_3Xg7",
	"limits__item--bordered": "CtnStatus_limits__item--bordered_2ruI",
	"limits__item--zero-left-padding": "CtnStatus_limits__item--zero-left-padding_1WvT"
};